import { Icon } from '@acast/decibel';
import { ImageSolidGlyph, LinkLightGlyph, VideoSolidGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React, { PureComponent } from 'react';
import { markerPropType } from '../../../../../../../customPropTypes';
import { DEFAULT_THUMBNAIL, MARKER_TYPES } from '../../../../../../../shared/helpers/markers';
import AnchorLine from './anchor-line';
import DragAndDropContainer from './drag-and-drop';

const MARKER_SIZE = 24;
const MARKER_FA_ICON = {
  [MARKER_TYPES.IMAGE]: ImageSolidGlyph,
  [MARKER_TYPES.LINK]: LinkLightGlyph,
  [MARKER_TYPES.VIDEO]: VideoSolidGlyph,
};

export default class MediaMarker extends PureComponent {
  getMarkerThumbnailImage() {
    const { marker } = this.props;
    const thumbnail = marker.thumbnail && marker.thumbnail.original;

    if (thumbnail === DEFAULT_THUMBNAIL) {
      return undefined;
    }

    return thumbnail;
  }

  renderContent() {
    const thumbnail = this.getMarkerThumbnailImage();
    if (thumbnail) {
      return <img alt={this.props.marker.type} src={thumbnail} width="100%" height="100%" />;
    }

    return <Icon glyph={MARKER_FA_ICON[this.props.marker.type]} size="1em" />;
  }

  render() {
    const { marker, markers, selected, ...restProps } = this.props;

    return (
      <DragAndDropContainer
        marker={marker}
        markers={markers}
        markerWidth={MARKER_SIZE}
        {...restProps}
      >
        {({ setRef, markerOffsetLeft, anchorLineOffsetLeft, onMouseDown }) => (
          <>
            {selected && <AnchorLine selected={selected} offsetLeft={anchorLineOffsetLeft} />}
            <div
              ref={setRef}
              className={`marker marker--media ${selected ? 'marker--selected' : ''}`}
              style={{
                width: MARKER_SIZE,
                height: MARKER_SIZE,
                left: markerOffsetLeft,
              }}
              data-test-id={`TimelineMarker TimelineMarker--${marker.id}`}
              onMouseDown={onMouseDown}
            >
              {this.renderContent()}
            </div>
          </>
        )}
      </DragAndDropContainer>
    );
  }
}

MediaMarker.defaultProps = {
  episodeDuration: 0,
};

MediaMarker.propTypes = {
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  selected: T.bool.isRequired,
  pixelsPerSecond: T.number.isRequired,
  episodeDuration: T.number,
};
